import * as React from 'react';
import type { SVGProps } from 'react';

const SvgMorvaridEnrollIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 120 120'
    fill='none'
    className={props.className}
    {...props}
  >
    <g filter='url(#morvaridEnrollIcon_svg__a)'>
      <path
        fill='url(#morvaridEnrollIcon_svg__b)'
        d='M0 0h108v108H0z'
        shapeRendering='crispEdges'
        transform='matrix(-1 0 0 1 108 4)'
      />
    </g>
    <defs>
      <pattern
        id='morvaridEnrollIcon_svg__b'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#morvaridEnrollIcon_svg__c' transform='scale(.00125 .00129)' />
      </pattern>
      <filter
        id='morvaridEnrollIcon_svg__a'
        width={108}
        height={108}
        x={0}
        y={0}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_26904_47129' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_26904_47129' result='shape' />
      </filter>
      <image
        xlinkHref='/images/icons/morvarid-enroll-icon-9953b396.webp'
        id='morvaridEnrollIcon_svg__c'
        width={802}
        height={775}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgMorvaridEnrollIcon;
